export default __webpack_public_path__ + "static/media/slide-2-mob.221c22e3.jpg";